export const PAGES = {
  LANDING: "LANDING",
  CAN_REDUCE: "CAN_REDUCE",
  ALREADY_AT_MINIMUM_CREDIT_LIMIT: "ALREADY_AT_MINIMUM_CREDIT_LIMIT",
  OVER_CREDIT_LIMIT: "OVER_CREDIT_LIMIT",
  FORM: "FORM",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export const CREDIT_LIMIT_DECREASE_HATEOAS_KEY = "credit_limit_decrease";
export const HEADING = "Reduce credit limit";
export const ERROR_HEADING = "Oops, something went wrong";
export const START_CLICKED = "START_CLICKED";
export const REDUCE_CREDIT_LIMIT_SUCCEEDED = "REDUCE_CREDIT_LIMIT_SUCCEEDED";
export const REDUCE_CREDIT_LIMIT_FAILED = "REDUCE_CREDIT_LIMIT_FAILED";
export const ACCOUNT_INFO_LOADED = "ACCOUNT_INFO_LOADED";
